export type CanonicalRoleCode =
  | 'super_admin'
  | 'admin'
  | 'manager'
  | 'cashier'
  | 'warehouse'
  | 'purchaser'
  | 'salesman';

const ROLE_ALIASES: Record<string, CanonicalRoleCode> = {
  super_admin: 'super_admin',
  admin: 'admin',
  store_owner: 'admin',
  store_manager: 'admin',
  manager: 'manager',
  finance_manager: 'manager',
  report_viewer: 'manager',
  supervisor: 'manager',
  cashier: 'cashier',
  warehouse: 'warehouse',
  inventory_clerk: 'warehouse',
  purchaser: 'purchaser',
  purchasing_manager: 'purchaser',
  salesman: 'salesman',
};

export function normalizeRoleCode(roleCode?: string | null): string {
  const raw = String(roleCode || '').trim().toLowerCase();
  return ROLE_ALIASES[raw] || raw;
}

export function getUserRoleCode(user: any): string {
  return normalizeRoleCode(user?.role_code || user?.role);
}

export function roleMatches(userRoleCode: string | null | undefined, allowedRoles: string[]): boolean {
  const normalizedUserRole = normalizeRoleCode(userRoleCode);
  if (!normalizedUserRole) return false;
  return allowedRoles.map(normalizeRoleCode).includes(normalizedUserRole);
}

export function hasAnyRole(userRoleCode: string | null | undefined, allowedRoles: string[], isSuperAdmin = false): boolean {
  if (isSuperAdmin) return true;
  return roleMatches(userRoleCode, allowedRoles);
}
